var SlideApp = (() => {
	var moveSlide = (slideContainer, direction = true, targetId = -1) => {
		const container = slideContainer.closest('[js-container]');
		var leftButton = null;
		var rightButton = null;
		if (container) {
			leftButton = container.querySelector('[js-left]');
			rightButton = container.querySelector('[js-right]');
		}
		var currentId = parseInt(slideContainer.getAttribute('data-current-id'));
		const totalId = parseInt(slideContainer.getAttribute('data-total-id'));
		if (direction) {
			currentId = (currentId + 1) % totalId;
		} else {
			currentId = (currentId - 1 + totalId) % totalId;
		}
		if (targetId > -1) {
			currentId = targetId;
		}
		const nextElement = slideContainer.querySelector(`[data-id="${currentId}"]`);
		if (!nextElement) return;
		slideContainer.scrollTo(nextElement.offsetLeft, 0);
		slideContainer.setAttribute('data-current-id', currentId);

		if (leftButton) {
			if (currentId == 0) leftButton.classList.add('disabled');
			else leftButton.classList.remove('disabled');
		}
		if (rightButton) {
			if (currentId == totalId - 1) rightButton.classList.add('disabled');
			else rightButton.classList.remove('disabled');
		}
		if (container) {
			container.querySelectorAll('.active[js-dot]').forEach(dot => {
				dot.classList.remove('active');
			});
			container.querySelectorAll(`[js-dot][data-id="${currentId}"]`).forEach(dot => {
				dot.classList.add('active');
			});
		}
	}

	var buttonClick = (slideContainer, button, direction) => {
		if (button.classList.contains('disabled')) return;
		moveSlide(slideContainer, direction);
	}

	var startAutoSlide = (slideContainer) => {
		if (!slideContainer.hasAttribute('data-slide-speed')) return;
		const slideSpeed = parseInt(slideContainer.getAttribute('data-slide-speed'));

		const timerId = setInterval(() => {
			moveSlide(slideContainer, true);
		}, slideSpeed*1000);
	}
	var initialize = () => {
		var scrollPos = [];
		document.querySelectorAll('[js-slide-container]').forEach((slideContainer, index) => {
			startAutoSlide(slideContainer);

			const container = slideContainer.closest('[js-container]');
			var leftButton = null;
			var rightButton = null;
			if (container) {
				leftButton = container.querySelector('[js-left]');
				rightButton = container.querySelector('[js-right]');
			}
			if (leftButton) {
				leftButton.addEventListener('click', () => {
					buttonClick(slideContainer, leftButton, false);
				});
			}
			if (rightButton) {
				rightButton.addEventListener('click', () => {
					buttonClick(slideContainer, rightButton, true);
				});
			}
			container.querySelectorAll('[js-dot]').forEach(dot => {
				dot.addEventListener('click', () => {
					moveSlide(slideContainer, true, dot.getAttribute('data-id'));
				});
			});
			scrollPos.push(0);
			slideContainer.addEventListener('touchstart', () => {
				scrollPos[index] = slideContainer.scrollLeft;
			});
			slideContainer.addEventListener('touchend', () => {
				if (slideContainer.scrollLeft > scrollPos[index]) {
					moveSlide(slideContainer, true);
				} else if (slideContainer.scrollLeft < scrollPos[index]) {
					moveSlide(slideContainer, false);
				}
			});
			slideContainer.addEventListener('touchcancel', () => {
				if (slideContainer.scrollLeft > scrollPos[index]) {
					moveSlide(slideContainer, true);
				} else if (slideContainer.scrollLeft < scrollPos[index]) {
					moveSlide(slideContainer, false);
				}
			});
		});
	}
	return {
		init: initialize
	}
})();

var CollapseApp = (() => {
	var open = (element) => {
		const container = element.closest('[js-container]');
		container.querySelectorAll('[js-collapsible]').forEach(e => {
			close(e);
		});
		element.classList.add('open');
		element.querySelector('[js-body]').style.maxHeight = element.querySelector('[js-body]').scrollHeight + 'px';
	}
	var close = (element) => {
		element.classList.remove('open');
		element.querySelector('[js-body]').style.maxHeight = '0px';
	}
	var initialize = () => {
		document.querySelectorAll('[js-collapsible]').forEach(element => {
			if (element.classList.contains('open')) {
				open(element);
			} else {
				close(element);
			}
			element.querySelector('[js-header]').addEventListener('click', () => {
				if (element.classList.contains('open')) {
					close(element);
				} else {
					open(element);
				}
			});
		});
	}
	return {
		init: initialize
	}
})();

var VideoElement = (() => {
	var initialize = () => {
		Array.from(document.querySelectorAll('.video-icon.play')).forEach((element) => {
			element.addEventListener('click', () => {
				element.closest('.video-container').classList.add('play');
				element.closest('.video-container').querySelector('video').play();
				element.closest('.video-container').classList.add('playing');
				element.closest('.video-container').querySelector('.video-icon.pause').classList.add('active');
				element.classList.remove('active');
			});
		});
		Array.from(document.querySelectorAll('.video-icon.pause')).forEach((element) => {
			element.addEventListener('click', () => {
				element.closest('.video-container').classList.remove('play');
				element.closest('.video-container').querySelector('video').pause();
				element.closest('.video-container').classList.remove('playing');
				element.classList.remove('active');
				element.closest('.video-container').querySelector('.video-icon.play').classList.add('active');
			});
		});
	}
	return {
		init: initialize
	}
})();

var HeaderSecondaryMenu = (() => {
	var closeImage = (container) => {
		if (!container) return;
		container.querySelectorAll('[js-header-child-link], [js-header-child-link-image]').forEach(element => {
			element.classList.remove('active');
		});
	}
	var openImage = (element) => {
		if (!element) return;
		const container = element.closest('[js-container]');
		if (!container) return;
		closeImage(container);
		container.querySelector(`[js-header-child-link-image][data-id="${element.getAttribute('data-id')}"]`).classList.add('active');
		container.querySelector(`[js-header-child-link][data-id="${element.getAttribute('data-id')}"]`).classList.add('active');
	}
	var initialize = () => {
		document.querySelectorAll('[js-header-child-link]').forEach(element => {
			element.addEventListener('mouseover', () => {
				openImage(element);
			});
		});
		document.querySelectorAll('.secondary-style-wrapper[js-container]').forEach(container => {
			container.addEventListener('mouseleave', () => {
				closeImage(container);
			})
		});
	}
	return {
		init: initialize
	}
})();

var ModalApp = (() => {
	var open = (modal) => {
		if (!modal) return;
		modal.classList.add('open');
	}
	var close = (modal) => {
		if (!modal) return;
		modal.classList.remove('open');
	}
	var initialize = () => {
		document.querySelectorAll('[js-modal-trigger]').forEach(element => {
			element.addEventListener('click', () => {
				open(document.querySelector(`[js-modal="${element.getAttribute('js-modal-trigger')}"]`));
			});
		});
		document.querySelectorAll('[js-modal] [js-close]').forEach(element => {
			element.addEventListener('click', () => {
				close(element.closest('[js-modal]'));
			});
		});
	}
	return {
		init: initialize
	}
})();

var ProductImageScroller = (() => {
	var update = () => {
		const mediaGrid = document.querySelector('.product-media-grid');
		const imageScroller = document.querySelector('.product-image-scroller');
		if (!mediaGrid || !imageScroller) return;
		const imageList = mediaGrid.querySelectorAll('.image-wrapper');
		for (let i = 0; i < imageList.length; i++) {
			if (imageList[i].getBoundingClientRect().top < imageList[i].clientHeight / 2 && imageList[i].getBoundingClientRect().top > -1 * imageList[i].clientHeight / 2) {
				imageScroller.querySelectorAll('.image-wrapper').forEach((image, index) => {
					if (index === i) {
						image.classList.add('selected');
					} else {
						image.classList.remove('selected');
					}
				}); 
			}
		}
	}
	var initialize = () => {
		window.addEventListener('scroll', () => {
			update();
		});
		document.querySelectorAll('.product-image-scroller .image-wrapper').forEach((element, index) => {
			element.addEventListener('click', () => {
				window.scrollTo(0, window.scrollY + document.querySelectorAll('.product-media-grid .image-wrapper')[index].getBoundingClientRect().top - 50);
			});
		});
	}
	return {
		init: initialize
	}
})();

var ProductVariantColorImageApp = (() => {
	var initialize = () => {
		document.addEventListener('variant-change', (e) => {
			const variant = e.detail.variant;
			const imageAlt = variant.featured_image.alt;
			if (imageAlt !== '') {
				document.querySelectorAll('.product-page .image-wrapper img').forEach(image => {
					if (image.alt !== imageAlt) {
						image.closest('.image-wrapper').classList.add('hide');
					} else {
						image.closest('.image-wrapper').classList.remove('hide');
					}
				});
				const slider = new Flickity(document.querySelector('.product-page .product-media-slider'));
				slider.resize();
			}
		});
	}
	return {
		init: initialize
	}
})();

var ProductVariantChangeApp = (() => {
	var update = (variant) => {
		if (!variant || !document.querySelector('product-info variant-selects')) return;
		fetch(`${document.querySelector('product-info variant-selects').dataset.url}?variant=${variant.id}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
				const currentPriceContainer = document.querySelector('.product-page .bullet-mobile-meta .price__container');
				const newPriceContainer = html.querySelector('.product-page .bullet-mobile-meta .price__container');
				if (currentPriceContainer && newPriceContainer) {
					currentPriceContainer.innerHTML = newPriceContainer.innerHTML;
				}
				const currentColorOptionContainer = document.querySelector('.product-page .selected-value');
				const newColorOptionContainer = html.querySelector('.product-page .selected-value');
				if (currentColorOptionContainer && newColorOptionContainer) {
					currentColorOptionContainer.innerHTML = newColorOptionContainer.innerHTML;
				}
			});
	}
	var initialize = () => {
		document.addEventListener('variant-change', (e) => {
			const variant = e.detail.variant;
			update(variant);
		});
	}
	return {
		init: initialize
	}
})();

var App = (() => {
	var initialize = () => {
		SlideApp.init();
		CollapseApp.init();
		VideoElement.init();
		HeaderSecondaryMenu.init();
		ModalApp.init();
		ProductImageScroller.init();
		ProductVariantColorImageApp.init();
		ProductVariantChangeApp.init();
	}
	return {
		init: initialize
	}
})();

document.addEventListener('DOMContentLoaded', () => {
	App.init();
});